module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0071.jpg?v=f8d8ddb1";